import * as Yup from 'yup';

export enum VALIDATORS {
  TEXT = 2048
}

export const productNameValidation = Yup.object({
  productName: Yup.string().max(
    VALIDATORS.TEXT,
    `Product Name must be at most ${VALIDATORS.TEXT} characters.`
  )
});

export const manufacturerNameValidation = Yup.object({
  manufacturerName: Yup.string()
    .required('Manufacturer Name is a required field')
    .max(
      VALIDATORS.TEXT,
      `Manufacturer Name must be at most ${VALIDATORS.TEXT} characters.`
    )
});

export const manufacturerSKUValidation = Yup.object({
  manufacturerSku: Yup.string()
    .required('Manufacturer SKU is a required field')
    .max(
      VALIDATORS.TEXT,
      `Manufacturer SKU must be at most ${VALIDATORS.TEXT} characters.`
    )
});

export const competitorSchema = [
  {
    name: 'productName',
    schema: productNameValidation
  },
  {
    name: 'manufacturerName',
    schema: manufacturerNameValidation
  },
  {
    name: 'manufacturerSku',
    schema: manufacturerSKUValidation
  }
];
